import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { CustomDateTimePickerComponent } from '../../custom-date-time-picker/custom-date-time-picker.component';

@Component({
    standalone: false,
    selector: 'res-download-ocr-usage-report-modal-modal',
    templateUrl: './download-ocr-usage-report-modal.component.html',
    styleUrls: ['./download-ocr-usage-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DownloadOCRUsageReportModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;
    @ViewChild('dateStart') dateStartComponent: CustomDateTimePickerComponent;
    @ViewChild('dateEnd') dateEndComponent: CustomDateTimePickerComponent;

    modalClass = 'download-ocr-usage-report';
    modalAutomationId = 'download-ocr-usage-report';
    modalHelpIndex = HelpIndex.sys_ocr_usage_report_download_dlg;
    defaultDatePlaceholders = ['Start YYYY-MM-DD ...', 'End YYYY-MM-DD ...'];
    ocrDateReportObject: any;
    dateError: boolean;
    filters: any[] = [];
    fullBackupData: any;
    invalidDate: boolean;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService,
        private changeDetector: ChangeDetectorRef
    ) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        this.ocrDateReportObject = {
            startDate: null, endDate: null,
        };
    }

    // if date picker input was clicked set input placeholder to YYYY-MM-DD
    // if x button or x button icon was clicked reset input placeholder to default
    onDateClick(datePicker: any, mode: any): void {
        if (datePicker && datePicker.target) {
            const crtControl = datePicker.target;
            const defaultPlaceholder = mode === 'start' ? this.defaultDatePlaceholders[0] : this.defaultDatePlaceholders[1];
            if (crtControl.placeholder) {
                if (this.defaultDatePlaceholders.indexOf(crtControl.placeholder) !== -1) {
                    crtControl.placeholder = 'YYYY-MM-DD';
                } else {
                    crtControl.placeholder = defaultPlaceholder;
                }
            } else if (crtControl.id === 'pickerClearBtn') {   // x button was clicked
                crtControl.parentElement.children['datepickerinput'].placeholder = defaultPlaceholder;
            } else if (crtControl.parentElement && crtControl.parentElement.id === 'pickerClearBtn') {  // x button icon was clicked
                crtControl.parentElement.parentElement.children['datepickerinput'].placeholder = defaultPlaceholder;
            }
        }
    }

    // on date picker input lost focus and date was not changed reset placeholder to default
    onFocusLost(datePicker: any, mode: any): void {
        if (datePicker && datePicker.target) {
            const crtControl = datePicker.target;
            const defaultPlaceholder = mode === 'start' ? this.defaultDatePlaceholders[0] : this.defaultDatePlaceholders[1];
            if (crtControl.placeholder) {
                if (this.defaultDatePlaceholders.indexOf(crtControl.placeholder) === -1) {
                    crtControl.placeholder = defaultPlaceholder;
                }
            }
        }
    }

    dateChanged(type?: any, value?: any): void {
        this.dateStartComponent?.errorPopover?.hide();
        this.dateEndComponent?.errorPopover?.hide();

        if (this.ocrDateReportObject?.startDate?.toString() === 'Invalid Date' || this.ocrDateReportObject?.endDate?.toString() === 'Invalid Date') {
            this.invalidDate = true;
        } else {
            this.invalidDate = false;
        }

        this.compareDateRange();
    }

    compareDateRange(): void {
        this.dateError = false;

        if ((this.ocrDateReportObject?.startDate && this.ocrDateReportObject?.endDate) && this.ocrDateReportObject?.endDate.getTime() < this.ocrDateReportObject?.startDate.getTime()) {
            this.dateError = true;
        } else {
            this.dateError = false;
        }

        this.changeDetector.detectChanges();
    }

    downloadOCRUsageReport() {
        this.filters = [];
        if (this.ocrDateReportObject.startDate) {
            (this.ocrDateReportObject.startDate).setUTCHours(0);
            (this.ocrDateReportObject.startDate).setUTCMinutes(0);
            (this.ocrDateReportObject.startDate).setUTCSeconds(0);

            this.filters.push({ attribute: "FROM_DATE", operator: "EQUALS", value: (this.ocrDateReportObject.startDate).getTime() });
        }
        if (this.ocrDateReportObject.endDate) {
            (this.ocrDateReportObject.endDate).setUTCHours(23);
            (this.ocrDateReportObject.endDate).setUTCMinutes(59);
            (this.ocrDateReportObject.endDate).setUTCSeconds(59);

            this.filters.push({ attribute: "TO_DATE", value: (this.ocrDateReportObject.endDate).getTime() });
        }

        this.restService.post(Endpoint.realmManager_getOCRUsageStatisticsUrl, {
            count: 0, startIndex: 0, filters: this.filters, systemScope: true
        }).then(response => {
            if (response) {
                if (response !== undefined && response.url !== null) {
                    this.commonService.unzipFile(response.url, this.downloadLink.nativeElement, 'ocrusagereport', this.filters);
                }
            }
        });
        this.closeModal();
    }
}
